/** 6 alphanumeric character pairs separated by colons. Case insensitive. Example: 01:23:45:67:89:aF */
const HEATPUMP_PAIRING_ID_REGEX = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/i
/** 6 alphanumeric character pairs separated by dashes. Case insensitive. Example: 01-23-45-67-89-aF */
const HEATPUMP_PAIRING_ID_WITH_MINUS_REGEX = /^([0-9A-F]{2}-){5}[0-9A-F]{2}$/i
/** 6 alphanumeric character pairs with no separator. Case insensitive. Example: 01-23-45-67-89-aF */
const HEATPUMP_PAIRING_ID_NO_COLON_REGEX = /^[0-9A-F]{12}$/i

export const isValidHeatpumpPairingId = (pairingId: string): boolean => {
  return (
    HEATPUMP_PAIRING_ID_REGEX.test(pairingId) ||
    HEATPUMP_PAIRING_ID_NO_COLON_REGEX.test(pairingId) ||
    HEATPUMP_PAIRING_ID_WITH_MINUS_REGEX.test(pairingId)
  )
}

/**
 * Given a Heatpump pairing id, it returns the id with colons in the right places.
 * If an invalid pairing id is given, it returns null.
 */
export const formatHeatpumpPairingId = (pairingId: string): string | null => {
  if (!isValidHeatpumpPairingId(pairingId)) return null
  const cleanId = pairingId.replaceAll(':', '').replaceAll('-', '')

  return `${cleanId[0]}${cleanId[1]}:${cleanId[2]}${cleanId[3]}:${cleanId[4]}${cleanId[5]}:${cleanId[6]}${cleanId[7]}:${cleanId[8]}${cleanId[9]}:${cleanId[10]}${cleanId[11]}`
}
